module.exports = __webpack_public_path__ + "static/media/kara_walker.401931ac.jpg";